import { render, staticRenderFns } from "./ModalCadastrarGestante.vue?vue&type=template&id=2c045878"
import script from "./ModalCadastrarGestante.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarGestante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports